// extracted by mini-css-extract-plugin
module.exports = {"Plan":"Plan_Plan__ypR6X"};